/*!
 * (C) PAQT.com B.V. https://paqt.com - MIT License
 */
export const HTMLElementSSR = (typeof HTMLElement !== 'undefined' ? HTMLElement : class {
});
//# sourceMappingURL=HTMLElementSSR.js.map
